type TChartPreset = {
  label: string
  value: string
  metrics: string[]
}

export const getMetricsChartPresets = (
  amazonEnabled: boolean,
  isGaMultiPropertyEnabled = false,
): Record<string, TChartPreset> => {
  // Determine which GA revenue metrics to use based on multi-property setting

  // Determine which baseline + paid brand search metric to use based on Amazon toggle
  let gaBaselinePlusPaidBrandSearch: string
  if (amazonEnabled) {
    gaBaselinePlusPaidBrandSearch = isGaMultiPropertyEnabled
      ? "metrics.ga_multi_property_amazon_baseline_revenue_plus_paid_brand_search"
      : "metrics.ga_amazon_baseline_revenue_plus_paid_brand_search"
  } else {
    gaBaselinePlusPaidBrandSearch = isGaMultiPropertyEnabled
      ? "metrics.ga_multi_property_revenue_baseline_plus_paid_brand_search"
      : "metrics.ga_revenue_baseline_plus_paid_brand_search"
  }

  return {
    BRANDED_SEARCH_ANALYSIS: {
      label: "Branded Search Analysis",
      value: "BRANDED_SEARCH_ANALYSIS",
      metrics: [
        "metrics.brand_factor",
        "metrics.google_search_organic_branded_search_impressions",
        "metrics.google_search_organic_branded_search_clicks",
        "metrics.google_ads_paid_branded_search_clicks",
        "metrics.total_google_search_clicks",
      ],
    },
    BASELINE_REVENUE_BRAND_VALUE: {
      label: "Baseline Revenue and Brand Value",
      value: "BASELINE_REVENUE_BRAND_VALUE",
      metrics: [
        "metrics.d30_brand_value",
        "metrics.d180_brand_value",
        gaBaselinePlusPaidBrandSearch,
        "metrics.shopify_amazon_baseline_revenue",
        "metrics.shopify_plus_subscription_amazon_baseline_revenue",
        "metrics.shopify_baseline_plus_paid_brand_search_revenue",
        "metrics.shopify_baseline_plus_subscription_plus_paid_brand_search_revenue",
      ],
    },
    BRAND_MONETIZATION: {
      label: "Brand & Monetization",
      value: "BRAND_MONETIZATION",
      metrics: [
        "metrics.d180_brand_value",
        "metrics.brand_factor",
        "metrics.monetization_factor",
        "metrics.google_search_organic_branded_search_impressions_unattributed",
      ],
    },
  }
}

export type TAllMetricsChartsKey = keyof ReturnType<
  typeof getMetricsChartPresets
>
